export default {
    appVersionUpdates: {
        title: 'App Version Config',
        description: 'Manage client update thresholds and multilingual release notes. Devices below the configured version receive update prompts (modal or badge-only, depending on type).',
        action: {
            publish: 'Publish Update',
            disable: 'Disable',
            enable: 'Enable',
            disableConfirm: 'Disable this record? Clients will no longer receive this configuration.',
            enableConfirm: 'Enable this record again?',
        },
        filter: {
            time: 'Published At',
            timeAll: 'All Time',
            time7d: 'Last 7 Days',
            time30d: 'Last 30 Days',
            timeCustom: 'Custom Range',
            customRange: 'Custom Range',
            channel: 'Channel',
            type: 'Update Type',
            status: 'Status',
            all: 'All',
        },
        table: {
            idTime: 'Record ID / Published At',
            channels: 'Channels & Versions',
            type: 'Update Type',
            status: 'Status',
            contents: 'Release Notes',
            publisher: 'Publisher',
        },
        type: {
            Remind: {
                title: 'Remind Update',
                desc: 'Non-blocking update with dismissible dialog. Used for regular releases, startup checks, and settings-version checks.',
            },
            Force: {
                title: 'Force Update',
                desc: 'Blocking update with no dismiss action. Use only for major releases or critical bugs.',
            },
            RemindOnly: {
                title: 'Remind Only',
                desc: 'Non-blocking update without a modal. Shows a new-version badge in settings and similar entry points. Use for lightweight releases when you do not want to interrupt users.',
            },
            clickHint: 'Settings-version checks and cold/hot startup all use server-side delivery. Remind and Force show modals; RemindOnly shows a reminder without a modal.',
        },
        status: {
            Enabled: 'Enabled',
            Disabled: 'Disabled',
        },
        channel: {
            ios: {
                label: 'iOS',
                short: 'iOS',
            },
            android: {
                label: 'Android (Google Play)',
                short: 'Android',
            },
            apk: {
                label: 'Official APK',
                short: 'APK',
            },
        },
        form: {
            updateType: 'Update Type',
            channels: 'Channels, Version Threshold & Links',
            channelsHint: 'Select channels to publish updates and fill threshold version plus store/download links. Unchecked channels are excluded.',
            versionThreshold: 'Prompt below version',
            downloadUrl: 'Update link',
            i18n: 'Release Notes (I18n)',
            i18nHint: 'Clients match copy by system language; missing locales fall back to English (EN).',
        },
        i18n: {
            zh: { required: '🇨🇳 ZH (Required)' },
            en: { required: '🇺🇸 EN (Required)' },
            ja: '🇯🇵 JA',
            es: '🇪🇸 ES',
            vi: '🇻🇳 VI',
            tr: '🇹🇷 TR',
        },
        modal: {
            createTitle: 'Publish App Update',
            editTitle: 'Edit Config ({id})',
            submit: 'Submit',
        },
        validation: {
            channelRequired: 'Select at least one channel',
            iosVersionRequired: 'Enter iOS version',
            iosVersionFormat: 'iOS version must be x.y.z',
            iosUrlRequired: 'Enter iOS update link',
            androidVersionRequired: 'Enter Android version',
            androidVersionFormat: 'Android version must be x.y.z',
            androidUrlRequired: 'Enter Android update link',
            apkVersionRequired: 'Enter APK version',
            apkVersionFormat: 'APK version must be x.y.z',
            apkUrlRequired: 'Enter APK download link',
            zhRequired: 'Chinese (ZH) is required',
            enRequired: 'English (EN) is required',
        },
        message: {
            loadFailed: 'Failed to load',
            saveFailed: 'Failed to save',
            createSuccess: 'Published successfully',
            updateSuccess: 'Changes saved',
            statusUpdated: 'Status updated',
        },
    },
};
